import HeaderFilter from "../../../components/shared/dashboard-header/HeaderFilter";
import useHeaderCustomLabelsItem from "../../../components/hooks/useHeaderCustomLabelsItem";
import { OVERALL_CARDS_LABELS, OVERALL_CARDS_TYPE } from "../../../types/overall.type";

export const headerItemsData = [
    { label: OVERALL_CARDS_LABELS.totalMain, type: "label", dataKey: OVERALL_CARDS_TYPE.TOTAL, isMain: true },
    { label: OVERALL_CARDS_LABELS.totalOutgoing, type: "label", dataKey: OVERALL_CARDS_TYPE.TOTAL_OUTGOING, isMain: true },
    { label: OVERALL_CARDS_LABELS.totalIncoming, type: "label", dataKey: OVERALL_CARDS_TYPE.TOTAL_INCOMING, isMain: true },

    { label: OVERALL_CARDS_LABELS.doctorData, dataKey: OVERALL_CARDS_TYPE.DOCTOR_DATA },
    { label: OVERALL_CARDS_LABELS.insuranceData, dataKey: OVERALL_CARDS_TYPE.INSURANCE_DATA },
    { label: OVERALL_CARDS_LABELS.floorsData, dataKey: OVERALL_CARDS_TYPE.FLOORS_DATA },
    { label: OVERALL_CARDS_LABELS.ninetyDaysData, dataKey: OVERALL_CARDS_TYPE.NINETY_DAYS_DATA },
    { label: OVERALL_CARDS_LABELS.daysData, dataKey: OVERALL_CARDS_TYPE.DAYS_DATA },

];

const OverallHeaderFilterList = ({
    filterListData,
    cardFilter,
    transferType,
    percentageBy,
    lockedTotal,
    lockedTotalBy,
    openFrom = "default", // "detailView"
    dynamicCards = [],
    isMobile = false,
    renderCardFilterPopover,
    interactiveHeaderFilterPopoverSlowTransition = false,
}) => {
    const headerItemsDataArray = useHeaderCustomLabelsItem(cardFilter, dynamicCards, headerItemsData);

    return <HeaderFilter
        items={headerItemsDataArray}
        filterListData={filterListData}
        cardFilter={cardFilter}
        transferType={transferType}
        percentageBy={percentageBy}
        lockedTotal={lockedTotal}
        lockedTotalBy={lockedTotalBy}
        openFrom={openFrom}
        isMobile={isMobile}
        renderCardFilterPopover={renderCardFilterPopover}
        interactiveHeaderFilterPopoverSlowTransition={interactiveHeaderFilterPopoverSlowTransition}
    />
};

export default OverallHeaderFilterList;